import { formFieldsConfigProcessed } from "./config/ShipmentDetailsConfig";
import { formFieldsState } from "./state/ShipmentDetailsState";
import { formFieldsValidation } from "./validations/ShipmentDetailsValidations";
import { SHIPMENT_DETAILS_CONSTANTS } from "../../constants";

export const formName = SHIPMENT_DETAILS_CONSTANTS.FORM_NAME;
export const formHeader = SHIPMENT_DETAILS_CONSTANTS.FORM_HEADER;
export const formDescription = SHIPMENT_DETAILS_CONSTANTS.FORM_DESCRIPTION;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;
export const formState = formFieldsState;
